<script lang="ts">
	import { m } from '$lib/paraglide/messages';

	const { socials }: { socials: Record<string, string> } = $props();

	const icons: Record<string, string> = {
		Facebook: 'icon-[streamline-logos--facebook-logo-2-block]',
		Instagram: 'icon-[mdi--instagram]',
		X: 'icon-[streamline-logos--x-twitter-logo-solid]',
		YouTube: 'icon-[mdi--youtube]',
		Pinterest: 'icon-[mdi--pinterest]',
		TikTok: 'icon-[streamline-logos--tiktok-logo-solid]',
	};
</script>

<div
	class="mt-4 flex flex-col border-t pt-4 text-center xl:mt-0 xl:border-none xl:pt-0 xl:text-left"
>
	<h3 class="mb-2 font-bold uppercase">{m['footer.socials.stay_connected']()}</h3>
	<p class="mb-2">{m['footer.socials.find_us']()}</p>
	<div class="flex flex-wrap justify-center gap-4 xl:justify-start">
		{#each Object.entries(socials) as [social, link] (social)}
			<a href={link} aria-label={social} rel="nofollow">
				<span class="{icons[social]} h-8 w-8 text-white sm:h-10 sm:w-10"></span>
			</a>
		{/each}
	</div>
</div>
